import { combineEpics } from 'redux-observable'
import { BootstrapEpics } from './Bootstrap'
import { DevicesEpics } from './Devices'
import { LicenseMgmtEpics } from './License'
import { OrganizationEpics } from './Organization/epics'
import { UserEpics } from './User/epics'
import { ClaimEpics } from './Claims/epics'
import { RolesEpics } from './Role/epics'
import { UsersEpics } from './AdminUser/epics'
import { StaffEpics } from './Staff/epics'
import { GroupEpics } from './Groups/epics'
import { OrganizationRoleEpics } from './OrganizationRoles/epics'
import { ClientEpics } from './Client/epics'
import { OpenIddictApplicationEpics } from './OpenIddictApplications'
import { LoginBrandingEpics } from './LoginBranding'
import { ServicePrincipalEpics } from './ServicePrincipal/epics'
import { ApiKeyEpics } from './ApiKey/epics'
import { ProductEpics } from './Products'

const rootEpic = combineEpics(
  ...BootstrapEpics,
  ...UsersEpics,
  ...RolesEpics,
  ...OrganizationEpics,
  ...DevicesEpics,
  ...UserEpics,
  ...LicenseMgmtEpics,
  ...ClaimEpics,
  ...StaffEpics,
  ...GroupEpics,
  ...OrganizationRoleEpics,
  ...ClientEpics,
  ...OpenIddictApplicationEpics,
  ...LoginBrandingEpics,
  ...ServicePrincipalEpics,
  ...ApiKeyEpics,
  ...ProductEpics,
)

export default rootEpic
